import io from "socket.io-client";

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect(url, userId) {
    this.socket = io(url, {
      transports: ["websocket"],
      query: {
        userId: userId,
        role: 'customer',
      },
      secure: true,
    });

    this.socket.on("connect", () => {
      this.isConnected = true;
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.isConnected = false;
    }
  }

  sendMessage(data) {
    if (this.isConnected) {
      this.socket.emit("sendMessage", data);
    }
  }

  sendRobotMessage(data) {
    if (this.isConnected) {
      this.socket.emit("sendRobotMessage", data);
    }
  }

  joinChat(data) {
    if (this.isConnected) {
      this.socket.emit("joinChat", data);
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }
}

export default new SocketService();
